import React from 'react';
import { connect } from 'react-redux';
 
 
import AdBanner from '../ad-banner/zone3';
 
const AppFooter = (props) => {
const {myfootermenu } = props;
 
	if (myfootermenu){	
		return (
			<div dangerouslySetInnerHTML={{ __html: myfootermenu }} />
		);
	} else {
		return (
			<div className="Footer">
				<AdBanner adUnit="728x90_leaderboard_zone3" type="simple"/>
			</div>		
		);
	}
}

export default connect(
  (state) => ({
    currentIssue: state.magazine.currentIssue
  }),
 
)(AppFooter); 


// WEBPACK FOOTER //
// ./src/components/app-footer/index.js